// main
import "../sass/main.scss";

import './modules/hamburger.js';

console.log('in main');